import { SectionHeader } from "@/components/common/section-components/SectionHeader";
import { Card, Field, Flex, Input, Text } from "@chakra-ui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldValues, useForm, useWatch } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { roleCreationSchema } from "../schema/roles.schema";
import { AppRoutes } from "@/constants/routes";
import { PermissionsTable } from "@/components/common/section-components/PermissionsTable";
import { useEffect, useState } from "react";
import {
  Permiso,
  Rol,
} from "@/pages/role-asignation/schema/role-assignation.schema";
import { useRoles } from "@/hooks/useRoles";
import { fetchPermissionsHandler, fetchRolDataHandler, handleUpdateRole } from "../schema/handler-functions";


export const EditRolePage = () => {
  const { id } = useParams();

  const [currentRol, setCurrentRol] = useState<Rol | undefined>();
  const [isActive, setIsActive] = useState<boolean>(false);

  const [loadingRolData, setLoadingRolData] = useState<boolean>(false);

  const [loadingUpdateRol, setLoadingUpdateRol] = useState<boolean>(false);

  const [loadingPermissions, setLoadingPermissions] = useState<boolean>(false);

  const fetchRolData = async () => {
  await fetchRolDataHandler({
    id,
    setCurrentRol,
    setLoadingRolData
  })
  };

  const { fetchPermissions: fetchUserPermissions } = useRoles();

  const [permissions, setPermissions] = useState<Permiso[] | null>([]);

  const navigate = useNavigate();

  const { fetchPermissions: fetchPermissionsUser } = useRoles();

  const fetchPermissions = async () => {
   await fetchPermissionsHandler({
    fetchPermissions: fetchPermissionsUser,
    navigate,
    setLoadingPermissions,
    setPermissions
   })
  };

  useEffect(() => {
    setIsActive(true);
  }, []);

  useEffect(() => {
    if (isActive) {
      fetchPermissions();
      fetchRolData();
    }
  }, [isActive]);

  const handleCancel = () => {
    navigate(-1);
  };

  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(roleCreationSchema),
    mode: "onChange",
    defaultValues: {
      name: "",
      permissions: [],
    },
  });

  const [permissionSelection, name] = useWatch({
    control,
    name: ["permissions", "name"],
  });

  useEffect(() => {
    if (currentRol) {
      setValue("name", currentRol?.nombre);
      setValue(
        "permissions",
        currentRol?.permisos?.map((el) => el?.id),
      );
    }
  }, [currentRol]);

  const setPermissionSelection = (value?: number[]) => {
    setValue("permissions", value ?? []);
  };
  const onSubmit = async (event: FieldValues) => {
    await handleUpdateRole({
      data: event,
      fetchPermissions: fetchUserPermissions,
      // eslint-disable-next-line @typescript-eslint/no-misused-promises -- navigate devuelve void, esto es un falso positivo
      navigate,
      redirectPath: AppRoutes.ROLES,
      roleId: currentRol?.id ?? 0,
      setLoading: setLoadingUpdateRol,
    });
  };

  return (
    <Flex flexDir="column" paddingTop="20px" data-testid="edit-role-page">
      <SectionHeader
        title={`Editar Rol`}
        addButtonLabel="Aceptar"
        cancelButtonLabel="Cancelar"
        handleAdd={handleSubmit(onSubmit)}
        handleCancel={handleCancel}
        loading={loadingRolData || loadingPermissions || loadingUpdateRol}
        disableAdd={!permissionSelection?.length || !name?.length}
      />
      <Card.Root maxW="full" marginTop="10px">
        <Card.Body paddingX="48px" paddingY="30px">
          <Flex flexDir="column" gap="30px">
            <Field.Root
              invalid={!!errors?.name?.message}
              display="flex"
              flexDir="column"
              gap="12px"
              maxWidth="300px"
            >
              <Field.Label>
                <Text fontWeight={600} fontSize="14px">
                  Nombre
                </Text>
              </Field.Label>
              <Input
                placeholder="Nombre del rol"
                paddingLeft="12px"
                {...register("name")}
                disabled={
                  loadingUpdateRol || loadingPermissions || loadingRolData
                }
              />
              <Field.ErrorText>{errors?.name?.message}</Field.ErrorText>
            </Field.Root>
            <PermissionsTable
              permissions={permissions || []}
              permissionSelection={permissionSelection}
              setPermissionSelection={setPermissionSelection}
              disableAll={
                loadingPermissions || loadingRolData || loadingUpdateRol
              }
            />
          </Flex>
        </Card.Body>
      </Card.Root>
    </Flex>
  );
};
